import { LANGS, detectLang } from "./diagnosticInauguralI18n";

const TEXTS = {
  fr: {
    confirmedKicker: "Adresse confirmée", confirmedTitle: "Votre email est confirmé",
    confirmedBody: "Merci. Votre lecture détaillée du Diagnostic Inaugural vous est envoyée par email dans les prochaines minutes.",
    home: "Retour à l'accueil",
    errorKicker: "Lien de confirmation", errorTitle: "Lien de confirmation invalide ou expiré",
    errorBody: "Veuillez soumettre à nouveau le formulaire pour recevoir un nouveau lien.", retry: "Refaire ma demande",
  },
  en: {
    confirmedKicker: "Address confirmed", confirmedTitle: "Your email is confirmed",
    confirmedBody: "Thank you. Your detailed Inaugural Diagnostic reading is being sent to you by email within the next few minutes.",
    home: "Back to home",
    errorKicker: "Confirmation link", errorTitle: "Invalid or expired confirmation link",
    errorBody: "Please submit the form again to receive a new link.", retry: "Submit again",
  },
  es: {
    confirmedKicker: "Dirección confirmada", confirmedTitle: "Su email está confirmado",
    confirmedBody: "Gracias. Su lectura detallada del Diagnóstico Inaugural se le envía por email en los próximos minutos.",
    home: "Volver al inicio",
    errorKicker: "Enlace de confirmación", errorTitle: "Enlace de confirmación no válido o caducado",
    errorBody: "Por favor, vuelva a enviar el formulario para recibir un nuevo enlace.", retry: "Volver a solicitar",
  },
  pt: {
    confirmedKicker: "Endereço confirmado", confirmedTitle: "O seu email está confirmado",
    confirmedBody: "Obrigado. A sua leitura detalhada do Diagnóstico Inaugural é-lhe enviada por email nos próximos minutos.",
    home: "Voltar ao início",
    errorKicker: "Ligação de confirmação", errorTitle: "Ligação de confirmação inválida ou expirada",
    errorBody: "Por favor, submeta novamente o formulário para receber uma nova ligação.", retry: "Pedir novamente",
  },
};

export const emailPageTexts = (search) => {
  const q = new URLSearchParams(search || "").get("lang");
  const lang = LANGS.includes(q) ? q : detectLang();
  return { lang, tx: TEXTS[lang] };
};
